import React, { createContext, useContext, useState, useRef } from 'react';

const NavigationContext = createContext();

export function NavigationProvider({ children }) {
  // direction: 1 = forward (swipe left, go right), -1 = backward (swipe right, go left)
  const [direction, setDirection] = useState(1);
  const directionRef = useRef(1);

  const setNavigationDirection = (dir) => {
    directionRef.current = dir;
    setDirection(dir);
  };

  return (
    <NavigationContext.Provider value={{ direction, directionRef, setNavigationDirection }}>
      {children}
    </NavigationContext.Provider>
  );
}

export function useNavigationDirection() {
  const context = useContext(NavigationContext);
  if (!context) {
    return { direction: 1, directionRef: { current: 1 }, setNavigationDirection: () => {} };
  }
  return context;
}
